import Swiper from 'swiper/bundle';

jQuery(function ($) {

  $(function () {
    if ($('.mySwiper').length) {
      var swiper = new Swiper('.mySwiper', {
        initialSlide: 0,
        // loop: false,
        autoHeight: false,
        slidesToShow: 4,
        slidesPerView: 4,
        slidesToScroll: 1,
        centeredSlides: false,
        slidesOffsetAfter: 0,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          320: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 45,
          }
        },
      });
    }
  });

});
